import React, {memo, useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {DEVELOPER_URL} from '../../index';
import {SettingsList, ColumnModel} from '../../../../components/Settings/SettingsList';
import {CameraBrandModel} from '../../../../types/control';
import {useSelector} from 'react-redux';
import {useLocalization} from "../../../../hooks/localization";

const keyExtractor = (item: CameraBrandModel) => item.id;

export const CameraBrandListScreen = memo(function CameraBrandListScreen() {
    const {t} = useLocalization();
    const cameraBrandList = useSelector(state => state.control.cameraBrandList);

    const [selected, setSelected] = useState<CameraBrandModel>(null);

    const buttons = useMemo(() => [
        {
            text: t('edit'),
            url: `/developer/camera-brand/edit/${selected ? selected.id : ''}`,
            className: 'orange',
            hidden: !(selected),
        },
        {
            text: t('create_camera_brand'),
            url: '/developer/camera-brand/edit',
            className: 'green',
        },
    ], [t, selected]);

    const displayNameExtractor = useCallback((item: CameraBrandModel, column: ColumnModel) => {
        return item[column.key] || '-';
    }, []);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('camera_brand_name'),
            key: 'name',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole='developer' isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                backUrl={DEVELOPER_URL}
                className="camera-list-page">
                <SettingsList
                    columns={columns}
                    items={cameraBrandList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selected}
                    onItemSelected={setSelected}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
